import { ModalStore } from '../../state/ModalStore'
import ModalHeader from './ModalHeader'
import ModalContent from './ModalContent'
import ModalContentWrapper from './ModalContentWrapper'
import ModalMainWrapper from './ModalMainWrapper'

const ImageModal = ({ name, url }) => {
    const skimModal = ModalStore((state) => state.skim)

    return (
        <ModalMainWrapper>
            <ModalContentWrapper>
                <ModalHeader title={name} />
                <ModalContent>
                    <img src={url} onClick={skimModal} />
                </ModalContent>
            </ModalContentWrapper>
        </ModalMainWrapper>
    )
}

export default ImageModal
